import PropTypes from "prop-types";

export default {
	id: PropTypes.string,
};
